require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./specialized-crisis-response-for-persons-with-mental-illness.json") })
        }
      }, "path---specialized-crisis-response-for-persons-with-mental-illness");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---specialized-crisis-response-for-persons-with-mental-illness!./.cache/json/specialized-crisis-response-for-persons-with-mental-illness.json
// module id = 983
// module chunks = 231608221292675